// i18n.js
import { createI18n } from "vue-i18n";
import en from "./locales/en";
import gr from "./locales/gr";

const savedLocale = typeof window !== "undefined" ? window.localStorage.getItem("aipath-locale") : null;
const initialLocale = ["gr", "en"].includes(savedLocale) ? savedLocale : "gr";

const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: "gr",
  messages: {
    en,
    gr,
    // Add more locales as needed
  },
});

export default i18n;
